import { render, staticRenderFns } from "./wy-bot-analytics-alert-template.vue?vue&type=template&id=7e640a84&"
import script from "./wy-bot-analytics-alert-template.vue?vue&type=script&lang=js&"
export * from "./wy-bot-analytics-alert-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports